import cn from 'classnames'
import styles from './scenario-pill.module.scss'

/**
 * @param {{
 *   active?: boolean,
 *   label: string,
 *   className?: string
 * }} props
 */
export function ScenarioPill({active = false, label, className}) {
    return (
        <span
            className={cn(styles.pill, {[styles.live]: active, [styles.dormant]: !active}, className)}
            aria-label={`Status: ${label}`}
        >
            <span className={styles.dot} aria-hidden="true"/>
            <span className={styles.label}>{label}</span>
        </span>
    )
}
